<template>
    <div
		class="radio-button-container no-highlight"
		:class="containerClasses"
		@click="click"
		@keydown.enter="click"
		role="radio"
		:tabindex="isTabbable"
		:aria-label="ariaLabel">
        <div class="radio-button--circle" :class="activeClass">
			<BaseIcon class="radio-button--icon circle-icon"
				icon="circle"/>
			<BaseIcon class="radio-button--icon check-icon"
				:isCustom="true"
				icon="radioButtonSelected"
				:fill="false"
				size="1x"/>
        </div>
        <div class="option-choice-name" :class="activeClass">
            {{ name }}
        </div>
        <slot></slot>
    </div>
</template>

<script>
    const warningMessage = `${this.name} from BaseRadio is missing click functionality.`;

    export default {
        props: {
            name: {
                type: String,
                default: "Channel Name"
            },
            activeClass: {
                type: String,
                default: ""
            },
            click: {
                type: Function | Promise,
                default: () => {
                    console.warn(warningMessage);
                }
            },
            classes: {
                type: String | Object,
                default: ""
			},
			ariaLabel: {
				type: String,
				default: '',
			}
        },
        computed: {
            containerClasses() {
                return `${this.activeClass} ${this.classes}`;
			},
			isTabbable() {
				if (this.ariaLabel !== '') {
					return '0';
				}
				return '-1';
			},
		},
		methods: {
			isSelected() {
				if (this.activeClass === 'selected') {
					return 'radioButtonSelected';
				}
				return 'circle';
			}
		}
    }
</script>

<style lang="scss" scoped>
    @import 'globalStyles';

    .radio-button-container {
        display: flex;
        flex: 1;
        align-items: center;
        margin: 0.3rem;

		font-weight: 500;

		&.disabled {
			cursor: not-allowed;
		}
		
		.option-choice-name {
			cursor: pointer;
			
			max-width: 50vw;

			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			&.selected {
				color: $storeButtonColor;

				font-weight: bold;
			}
			&.disabled {
				color: $storeButtonDisabled;

				cursor: not-allowed;
			}
		}
	}

	.radio-button--circle {
		flex-shrink: 0;
		position: relative;

		background-color: transparent;
		color: $greyOutline;
		font-size: 1.3rem;

		width: 2rem;
		height: 1.8rem;
		
		cursor: pointer;

		.radio-button--icon {
			position: absolute;
		}

		.check-icon {
			position: absolute;
			top: -3px;

			color: $storeButtonColor;

			font-size: 1.5rem;

			transform: scale(0);
			transition: transform .15s ease-out;
		}

		&.selected {
			border-color: $storeButtonColor;

			.check-icon {
				transform: scale(1);
			}
		}

		&.disabled {
			border-color: $storeButtonDisabled;

			cursor: not-allowed;
		}
	}
	
	.option-choice-wrapper {
		.radio-button-container {
			flex: 2;
		}
	}

	@include desktop {
		.radio-button-container {
			.option-choice-name {
				max-width: 13rem;
			}
		}
	}

	@include mobile {
		.radio-button-container {
			margin: 5px 0;
		}
		.mobile-radio {
			margin: 1rem 0rem;
		}
		.radio-button--circle {
				margin-right: 0.3rem;
		}
		.option-choice-wrapper {
			.radio-button-container {
				margin: 0.1rem 0.3rem;
			}
		}
		.detail--tablet-compact {
			.radio-button-container {
				.option-choice-name {
					max-width: 13em;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/common/BaseRadio.vue